export * from './accountDetails.service';
import { AccountDetailsService } from './accountDetails.service';
export * from './accounts.service';
import { AccountsService } from './accounts.service';
export const APIS = [AccountDetailsService, AccountsService];
